<template>
    <div>
        <!-- 搜索框 -->
        <a-card :title="this.title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form layout="inline" @submit="handleSubmit" :form="form">
                <a-form-item label="关键字">
                    <a-input v-model="searchP.keyword" placeholder="请输入关键字"></a-input>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" @click="handleSubmit">查询</a-button>
                </a-form-item>
                <a-form-item class="f-right">
                    <a-button type="primary" class="fr opbuttonmt" @click="dingyue">订阅接口</a-button>
                </a-form-item>
            </a-form>
        </a-card>

        <!-- 分组列表 -->
        <a-table :columns="columns" :data-source="data" :pagination="false" :loading="tLoading" rowKey="id">

            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <a-popconfirm title="确认删除?" @confirm="() => onDelete(record)">
                        <a href="javascript:;">删除</a>
                    </a-popconfirm>
                </div>
            </template>

        </a-table>
        <ServiceKeySelecter :modalState="modalStateServicekey" @onModalHide="onServiceKeyselecterHide"></ServiceKeySelecter>

        <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
import ServiceKeySelecter from '../../components/ServiceKeySelecter.vue'
let pagination = {
    total: 0,
    pageSize: 0,
    current: 1,
}
const columns = [
    {
        title: '序号',
        width: 80,
        align: 'center',
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination
            return (Number(current) - 1) * Number(pageSize) + index + 1
        },
    },
    {
        title: '系统编码',
        dataIndex: 'syscode',
        width: 80,
    },
    {
        title: '接口名称',
        dataIndex: 'servicekey',
        width: 150,
    },
    {
        title: '服务配置',
        dataIndex: 'serviceconfig',
        width: 200,
    },
    {
        title: '创建时间',
        dataIndex: 'createtime',
        width: 150,
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'operation' },
    },
]

export default {
    data() {
        return {
            title: '',
            form: this.$form.createForm(this),
            columns,
            pagination,
            data: [],
            searchP: {
                keyword: '',
                dingid: '',
                alerttype: '',
                flag: '',
            },
            tLoading: false,
            modalStateServicekey: {
                isShow: false,
                rowsType: 'checkbox',
                domain: '',
                selectkeys: [],
            },
            ConfigItem: [],
        }
    },
    methods: {
        onServiceKeyselecterHide(result) {
            // debugger
            if (result == undefined) {
                this.modalStateServicekey.isShow = false
                return
            }
            this.ConfigItem = []
            result.forEach((element) => {
                let item = {}
                item.servicekey = element.servicekey
                item.appcode = element.appcode
                item.serviceconfig = element.serviceconfig
                item.dingid = this.searchP.dingid
                item.alerttype = this.searchP.alerttype
                item.flag = this.searchP.flag
                // debugger
                this.ConfigItem.push(item)
            })
            if (this.ConfigItem.length <= 0) {
                return
            }
            let jsonarr = JSON.stringify(this.ConfigItem)
            console.log(jsonarr)
            this.$store
                .dispatch({
                    type: 'alarmconfig/relatedkey',
                    params: {
                        list: jsonarr,
                    },
                })
                .then(() => {
                    this.modalStateServicekey.isShow = false
                    this.getAlarmDingdingList(1)
                })
                .catch(() => {
                    this.modalStateServicekey.isShow = false
                })
        },
        dingyue() {
            this.modalStateServicekey.isShow = true
        },
        handlePageChange(c_p) {
            this.getAlarmDingdingList(c_p)
        },
        getAlarmDingdingList(cpage) {
            let c_params = {
                ...this.searchP,
            }
            c_params.page = cpage ? cpage : 1
            c_params.pageSize = this.pagination.pageSize
            c_params.urlparams = false
            this.tLoading = true
            this.$store
                .dispatch({
                    type: 'alarmconfig/querykeyspage',
                    params: c_params,
                })
                .then((res) => {
                    let result = res.data.data
                    if (result) {
                        this.data = result.list
                        this.pagination.total = parseInt(result.totalRecords)
                        this.pagination.pageSize = parseInt(result.pageSize)
                        this.pagination.current = parseInt(result.page)
                    }
                    this.tLoading = false
                })
                .catch(() => {
                    this.tLoading = false
                })
        },

        handleSubmit() {
            this.getAlarmDingdingList(1)
        },

        //删除
        onDelete(record) {
            this.$store
                .dispatch({
                    type: 'alarmconfig/delkey',
                    params: {
                        id: record.id,
                    },
                })
                .then(() => {
                    this.getAlarmDingdingList(this.pagination.current)
                })
        },
    },
    computed: {},
    components: {
        ServiceKeySelecter,
    },

    mounted() {
        const { query } = this.$route
        this.searchP.dingid = query.dingid
        this.searchP.alerttype = query.alerttype
        this.searchP.flag = query.flag
        this.title =
            (query.dingdingname ? query.dingdingname : '') +
            '（' +
            query.alerttype +
            '）-订阅接口'

        this.getAlarmDingdingList(1)
    },
}
</script>
<style scoped>
.editable-row-operations a {
    margin-right: 8px;
}
td {
    padding: 10px 10px;
}
</style>
